import { render } from "./Powerby.vue?vue&type=template&id=17a5ebb5&scoped=true"
import script from "./Powerby.vue?vue&type=script&lang=js"
export * from "./Powerby.vue?vue&type=script&lang=js"

import "./Powerby.vue?vue&type=style&index=0&id=17a5ebb5&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a5ebb5"]])

export default __exports__